import Vue from 'vue'
import { USER_INFO,USER_ROLE_CODE} from "@/store/mutation-types"
import {USER_EXPERT_ID} from "./mutation-types";
const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => {state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar},
  username: state => state.user.username,
  nickname: state => {state.user.realname = Vue.ls.get(USER_INFO).realname; return state.user.realname},
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  userInfo: state => {state.user.info = Vue.ls.get(USER_INFO); return state.user.info},
  addRouters: state => state.permission.addRouters,
  userRoleCode : state => {state.user.rolecode = Vue.ls.get(USER_ROLE_CODE);return state.user.rolecode},
  userExpertId : state => {state.user.userExpertId = Vue.ls.get(USER_EXPERT_ID);return state.user.userExpertId}
}

export default getters